export default __webpack_public_path__ + "static/media/trenza-azul.5f42b1f3.png";